// Frontend questions data
export const questionsData = [
  {
    storyId: 1,
    questions: [
      {
        id: "1-1",
        question: "Who felt most familiar to you?",
        marks: 2,
        options: [
          { label: "Nikhil", value: "Nikhil", persona: ["A","E"] },
          { label: "Tanya", value: "Tanya", persona: ["B","C"] },
          { label: "Jeevan", value: "Jeevan", persona: ["D","F"] },
        ],
      },
      {
        id: "1-2",
        question: "Who do you secretly admire?",
        marks: 1,
        options: [
          { label: "Nikhil", value: "Nikhil", persona: ["A","E"]  },
          { label: "Tanya", value: "Tanya", persona: ["B","C"] },
          { label: "Jeevan", value: "Jeevan", persona: ["D","F"] },
        ],
      },
      {
        id: "1-3",
        question: "Who made you uncomfortable?",
        marks: -1,
        options: [
          { label: "Nikhil", value: "Nikhil", persona: ["A","E"] },
          { label: "Tanya", value: "Tanya", persona: ["B","C"] },
          { label: "Jeevan", value: "Jeevan", persona: ["D","F"] },
        ],
      },
    ],
  },
  {
    storyId: 2,
    questions: [
      {
        id: "2-1",
        question: "Who felt most like you?",
        marks: 2,
        options: [
          { label: "Vikram", value: "Vikram", persona: "A" },
          { label: "Kabir", value: "Kabir", persona: "B" },
          { label: "Sana", value: "Sana", persona: "C" },
        ],
      },
      {
        id: "2-2",
        question: "Who did you admire?",
        marks: 1,
        options: [
          { label: "Vikram", value: "Vikram", persona: "A" },
          { label: "Kabir", value: "Kabir", persona: "B" },
          { label: "Sana", value: "Sana", persona: "C" },
        ],
      },
      {
        id: "2-3",
        question: "Who made you uneasy?",
        marks: -1,
        options: [
          { label: "Vikram", value: "Vikram", persona: "A" },
          { label: "Kabir", value: "Kabir", persona: "B" },
          { label: "Sana", value: "Sana", persona: "C" },
        ],
      },
    ],
  },
  {
    storyId: 3,
    questions: [
      {
        id: "3-1",
        question: "Who felt most like you?",
        marks: 2,
        options: [
          { label: "Priya", value: "Priya", persona: "E" },
          { label: "Anuj", value: "Anuj", persona: "D" },
          { label: "Naveen", value: "Naveen", persona: "A" },
        ],
      },
      {
        id: "3-2",
        question: "Who do you quietly admire?",
        marks: 1,
        options: [
          { label: "Priya", value: "Priya", persona: "E" },
          { label: "Anuj", value: "Anuj", persona: "D" },
          { label: "Naveen", value: "Naveen", persona: "A" },
        ],
      },
      {
        id: "3-3",
        question: "Who made you uncomfortable?",
        marks: -1,
        options: [
          { label: "Priya", value: "Priya", persona: "E" },
          { label: "Anuj", value: "Anuj", persona: "D" },
          { label: "Naveen", value: "Naveen", persona: "A" },
        ],
      },
    ],
  },
  {
    storyId: 4,
    questions: [
      {
        id: "4-1",
        question: "Who felt most like you in that room?",
        marks: 2,
        options: [
          { label: "Rajat", value: "Rajat", persona: "A" },
          { label: "Meera", value: "Meera", persona: "F" },
          { label: "Fatima", value: "Fatima", persona: "C" },
        ],
      },
      {
        id: "4-2",
        question: "Who surprised you?",
        marks: 1,
        options: [
          { label: "Rajat", value: "Rajat", persona: "A" },
          { label: "Meera", value: "Meera", persona: "F" },
          { label: "Fatima", value: "Fatima", persona: "C" },
        ],
      },
      {
        id: "4-3",
        question: "Who made you nervous?",
        marks: -1,
        options: [
          { label: "Rajat", value: "Rajat", persona: "A" },
          { label: "Meera", value: "Meera", persona: "F" },
          { label: "Fatima", value: "Fatima", persona: "C" },
        ],
      },
    ],
  },
  {
    storyId: 5,
    questions: [
      {
        id: "5-1",
        question: "Who felt most like you when you were new?",
        marks: 2,
        options: [
          { label: "Arjun", value: "Arjun", persona: "E" },
          { label: "Chhavi", value: "Chhavi", persona: "B" },
          { label: "Dev", value: "Dev", persona: "D" },
        ],
      },
      {
        id: "5-2",
        question: "Who did you relate to — even if you wouldn't act like them?",
        marks: 1,
        options: [
          { label: "Arjun", value: "Arjun", persona: "E" },
          { label: "Chhavi", value: "Chhavi", persona: "B" },
          { label: "Dev", value: "Dev", persona: "D" },
        ],
      },
      {
        id: "5-3",
        question: 'Who left you thinking, "I\'ve done that too"?',
        marks: -1,
        options: [
          { label: "Arjun", value: "Arjun", persona: "E" },
          { label: "Chhavi", value: "Chhavi", persona: "B" },
          { label: "Dev", value: "Dev", persona: "D" },
        ],
      },
    ],
  },
  {
    storyId: 6,
    questions: [
      {
        id: "6-1",
        question:
          "Who felt closest to how you've reacted in a sticky situation?",
        marks: 2,
        options: [
          { label: "Rhea", value: "Rhea", persona: "C" },
          { label: "Sahil", value: "Sahil", persona: "F" },
          { label: "Nitin", value: "Nitin", persona: "A" },
        ],
      },
      {
        id: "6-2",
        question: "Who made you pause?",
        marks: 1,
        options: [
          { label: "Rhea", value: "Rhea", persona: "C" },
          { label: "Sahil", value: "Sahil", persona: "F" },
          { label: "Nitin", value: "Nitin", persona: "A" },
        ],
      },
      {
        id: "6-3",
        question: "Who left you with questions about yourself?",
        marks: -1,
        options: [
          { label: "Rhea", value: "Rhea", persona: "C" },
          { label: "Sahil", value: "Sahil", persona: "F" },
          { label: "Nitin", value: "Nitin", persona: "A" },
        ],
      },
    ],
  },
  {
    storyId: 7,
    questions: [
      {
        id: "7-1",
        question: "Who did you instantly recognize yourself in?",
        marks: 2,
        options: [
          { label: "Varun", value: "Varun", persona: "D" },
          { label: "Lata", value: "Lata", persona: "E" },
          { label: "Om", value: "Om", persona: "B" },
        ],
      },
      {
        id: "7-2",
        question: "Who made you laugh… and then think?",
        marks: 1,
        options: [
          { label: "Varun", value: "Varun", persona: "D" },
          { label: "Lata", value: "Lata", persona: "E" },
          { label: "Om", value: "Om", persona: "B" },
        ],
      },
      {
        id: "7-3",
        question: "Who did something you've done — but never admitted?",
        marks: -1,
        options: [
          { label: "Varun", value: "Varun", persona: "D" },
          { label: "Lata", value: "Lata", persona: "E" },
          { label: "Om", value: "Om", persona: "B" },
        ],
      },
    ],
  },
  {
    storyId: 8,
    questions: [
      {
        id: "8-1",
        question:
          "Who felt most familiar when something you built was touched?",
        marks: 2,
        options: [
          { label: "Niyati", value: "Niyati", persona: "A" },
          { label: "Zubin", value: "Zubin", persona: "C" },
          { label: "Sana", value: "Sana", persona: "E" },
        ],
      },
      {
        id: "8-2",
        question: "Who played it smart — even if it felt political?",
        marks: 1,
        options: [
          { label: "Niyati", value: "Niyati", persona: "A" },
          { label: "Zubin", value: "Zubin", persona: "C" },
          { label: "Sana", value: "Sana", persona: "E" },
        ],
      },
      {
        id: "8-3",
        question: "Who's playing the middle — and what did it cost?",
        marks: -1,
        options: [
          { label: "Niyati", value: "Niyati", persona: "A" },
          { label: "Zubin", value: "Zubin", persona: "C" },
          { label: "Sana", value: "Sana", persona: "E" },
        ],
      },
    ],
  },
];